import { fetchWithAuth } from './config';

const getGroups = async () => {
  const groups = await fetchWithAuth('/groups');

  return groups;
};

const createGroup = async ({ name }: { name: string }) => {
  await fetchWithAuth('/groups', {
    method: 'POST',
    body: JSON.stringify({ name }),
  });

  return;
};

const deleteGroup = async (groupId: string) => {
  await fetchWithAuth(`/groups/${groupId}`, {
    method: 'DELETE',
  });
};

const addPermissionToGroup = async (groupId: string, permissionId: string) => {
  await fetchWithAuth(`/permissions/${permissionId}/groups`, {
    method: 'POST',
    body: JSON.stringify({ groupId }),
  });
};

const removePermissionFromGroup = async (groupId: string, permissionId: string) => {
  await fetchWithAuth(`/permissions/${permissionId}/groups/${groupId}`, {
    method: 'DELETE',
  });
};

const addUserToGroup = async (groupId: string, userId: string) => {
  await fetchWithAuth(`/groups/${groupId}/users`, {
    method: 'POST',
    body: JSON.stringify({ userId }),
  });
};

const removeUserFromGroup = async (groupId: string, userId: string) => {
  await fetchWithAuth(`/groups/${groupId}/users/${userId}`, {
    method: 'DELETE',
  });
};

const getGroupUsers = async (groupId: string) => {
  const users = await fetchWithAuth(`/groups/${groupId}/users`);
  return users;
};

const getGroupPermissions = async (groupId: string) => {
  const permissions = await fetchWithAuth(`/groups/${groupId}/permissions`);
  return permissions;
};

export {
  getGroups,
  createGroup,
  deleteGroup,
  addPermissionToGroup,
  removePermissionFromGroup,
  addUserToGroup,
  removeUserFromGroup,
  getGroupUsers,
  getGroupPermissions,
};
